import { useFilterChangeCallback, useDebouncedCallback } from 'shared/hooks';
import { FILTER_KEY } from '../constants';
import { useMemo } from 'react';

export const useBedroomsChangeHandler = () => {
  const onChange = useFilterChangeCallback(FILTER_KEY);

  const onMinChange = useDebouncedCallback((gte: number | null) => {
    onChange({ action: 'setBedroomsCountMin', arguments: [gte] });
  }, 300);

  const onMaxChange = useDebouncedCallback((lte: number | null) => {
    onChange({ action: 'setBedroomsCountMax', arguments: [lte] });
  }, 300);

  return useMemo(
    () => ({
      onMinChange,
      onMaxChange,
    }),
    [onMaxChange, onMinChange],
  );
};
